const STYLES = `
  @keyframes achat-spin   { to { transform: rotate(360deg); } }
  @keyframes achat-fadein { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:none} }
  @keyframes achat-slidein-left {
    from { transform: translateX(-100%); opacity: 0; }
    to   { transform: translateX(0);     opacity: 1; }
  }

  /* ── Root ── */
  .achat-root {
    display: flex;
    height: calc(100vh - 62px);
    background: var(--bg);
    overflow: hidden;
    position: relative;
  }

  /* ── Sidebar ── */
  .achat-sidebar {
    width: 280px; flex-shrink: 0;
    display: flex; flex-direction: column;
    border-right: 1px solid var(--line);
    background: var(--bg-1);
    transition: transform .25s cubic-bezier(.16,1,.3,1);
    z-index: 20;
  }

  /* Mobile: sidebar slides in as overlay */
  @media (max-width: 700px) {
    .achat-sidebar {
      position: absolute; inset-block: 0; left: 0;
      width: 82vw; max-width: 320px;
      transform: translateX(-100%);
      box-shadow: 4px 0 32px rgba(0,0,0,.45);
    }
    .achat-sidebar.open {
      transform: translateX(0);
      animation: achat-slidein-left .22s cubic-bezier(.16,1,.3,1);
    }
    .achat-sidebar-backdrop {
      position: absolute; inset: 0; z-index: 19;
      background: rgba(0,0,0,.45);
      animation: achat-fadein .15s;
    }
  }
  @media (min-width: 701px) {
    .achat-sidebar-backdrop { display: none !important; }
    .achat-mob-toggle { display: none !important; }
  }

  /* Sidebar header */
  .achat-sb-header {
    padding: 14px 14px 11px;
    border-bottom: 1px solid var(--line);
    flex-shrink: 0;
  }
  .achat-sb-title-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 9px;
  }
  .achat-sb-title {
    font-family: var(--display);
    font-size: 1rem; font-weight: 800;
    color: var(--text-1); letter-spacing: -.02em;
    display: flex; align-items: center; gap: 7px;
  }
  .achat-total-badge {
    min-width: 18px; height: 18px; border-radius: 100px; padding: 0 5px;
    background: #ef4444; color: #fff;
    font-size: .6rem; font-weight: 800;
    display: flex; align-items: center; justify-content: center;
  }
  .achat-new-btn {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 5px 10px; border-radius: 8px;
    background: rgba(79,142,247,.12); border: 1px solid rgba(79,142,247,.28);
    color: var(--blue); font-size: .73rem; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: background .13s;
    white-space: nowrap;
  }
  .achat-new-btn:hover { background: rgba(79,142,247,.22); }

  /* Sidebar search */
  .achat-search-wrap { position: relative; }
  .achat-search-icon {
    position: absolute; left: 10px; top: 50%;
    transform: translateY(-50%); color: var(--text-3); pointer-events: none;
  }
  .achat-search {
    width: 100%; padding: 7px 10px 7px 32px;
    background: var(--surface); border: 1px solid var(--line-2);
    border-radius: 9px; font-family: var(--body); font-size: .8rem;
    color: var(--text-1); outline: none; transition: border-color .14s;
    box-sizing: border-box;
  }
  .achat-search::placeholder { color: var(--text-3); }
  .achat-search:focus { border-color: var(--blue); }

  /* Conversation list */
  .achat-conv-list { flex: 1; overflow-y: auto; padding: 4px 0; }
  .achat-conv-list::-webkit-scrollbar { width: 3px; }
  .achat-conv-list::-webkit-scrollbar-thumb { background: rgba(255,255,255,.08); border-radius: 2px; }

  .achat-conv-item {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 13px; cursor: pointer;
    transition: background .11s;
    border-left: 2px solid transparent;
  }
  .achat-conv-item:hover  { background: rgba(255,255,255,.03); }
  .achat-conv-item.active { background: rgba(79,142,247,.09); border-left-color: var(--blue); }

  .achat-conv-av {
    width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-size: .72rem; font-weight: 800; color: #fff;
    background: linear-gradient(135deg, #4f8ef7, #7c3aed);
    position: relative;
  }
  .achat-conv-av-badge {
    position: absolute; bottom: -1px; right: -1px;
    width: 10px; height: 10px; border-radius: 50%;
    background: #ef4444; border: 1.5px solid var(--bg-1);
  }
  .achat-conv-info { flex: 1; min-width: 0; }
  .achat-conv-name {
    font-size: .84rem; font-weight: 600; color: var(--text-1);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .achat-conv-prev {
    font-size: .73rem; color: var(--text-3); margin-top: 1px;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .achat-conv-meta { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; flex-shrink: 0; }
  .achat-conv-time { font-size: .64rem; color: var(--text-3); white-space: nowrap; }
  .achat-conv-badge {
    min-width: 17px; height: 17px; border-radius: 100px; padding: 0 4px;
    background: #ef4444; color: #fff;
    font-size: .6rem; font-weight: 800;
    display: flex; align-items: center; justify-content: center;
  }
  .achat-empty-sb {
    padding: 1.5rem 1rem; text-align: center;
    color: var(--text-3); font-size: .78rem; line-height: 1.6;
  }

  /* ── User-picker modal ── */
  .achat-picker-overlay {
    position: fixed; inset: 0; z-index: 9500;
    background: rgba(0,0,0,.55);
    display: flex; align-items: center; justify-content: center;
    animation: achat-fadein .15s; padding: 1rem;
  }
  .achat-picker {
    background: var(--surface); border: 1px solid var(--line-2);
    border-radius: 16px; width: 100%; max-width: 380px; max-height: 500px;
    display: flex; flex-direction: column;
    box-shadow: 0 20px 60px rgba(0,0,0,.6);
    overflow: hidden;
    animation: achat-fadein .18s cubic-bezier(.16,1,.3,1);
  }
  .achat-picker-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 16px; border-bottom: 1px solid var(--line); flex-shrink: 0;
  }
  .achat-picker-title { font-size: .9375rem; font-weight: 700; color: var(--text-1); }
  .achat-picker-close {
    width: 28px; height: 28px; border-radius: 8px;
    background: rgba(255,255,255,.06); border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: var(--text-3); transition: background .12s;
  }
  .achat-picker-close:hover { background: rgba(255,255,255,.1); color: var(--text-1); }
  .achat-picker-search-wrap { padding: 10px 12px; border-bottom: 1px solid var(--line); flex-shrink: 0; }
  .achat-picker-search {
    width: 100%; padding: 8px 12px;
    background: var(--bg-1); border: 1px solid var(--line-2);
    border-radius: 9px; font-family: var(--body); font-size: .84rem;
    color: var(--text-1); outline: none; box-sizing: border-box;
    transition: border-color .14s;
  }
  .achat-picker-search::placeholder { color: var(--text-3); }
  .achat-picker-search:focus { border-color: var(--blue); }
  .achat-picker-list { flex: 1; overflow-y: auto; padding: 4px 0; }
  .achat-picker-item {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 14px; cursor: pointer; transition: background .11s;
  }
  .achat-picker-item:hover { background: rgba(255,255,255,.04); }
  .achat-picker-av {
    width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-size: .72rem; font-weight: 800; color: #fff;
    background: linear-gradient(135deg, #4f8ef7, #7c3aed);
  }
  .achat-picker-name { font-size: .875rem; font-weight: 600; color: var(--text-1); }
  .achat-picker-email { font-size: .73rem; color: var(--text-3); margin-top: 1px; }
  .achat-picker-empty { padding: 1.5rem; text-align: center; color: var(--text-3); font-size: .82rem; }

  /* ── Main pane ── */
  .achat-main { flex: 1; display: flex; flex-direction: column; min-width: 0; overflow: hidden; }

  /* No conversation selected */
  .achat-no-conv {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 12px; color: var(--text-3); text-align: center; padding: 2rem;
  }
  .achat-no-conv-icon {
    width: 68px; height: 68px; border-radius: 20px;
    background: rgba(79,142,247,.07); border: 1px solid rgba(79,142,247,.12);
    display: flex; align-items: center; justify-content: center; color: var(--blue); opacity:.5;
  }
  .achat-no-conv h3 {
    font-family: var(--display); font-size: 1rem; font-weight: 700;
    color: var(--text-2); margin: 0;
  }
  .achat-no-conv p { font-size: .8125rem; color: var(--text-3); margin: 0; max-width: 240px; }

  /* ── Conversation header ── */
  .achat-conv-hdr {
    display: flex; align-items: center; gap: 10px;
    padding: 11px 14px; border-bottom: 1px solid var(--line);
    background: var(--bg-1); flex-shrink: 0;
    flex-wrap: wrap;
    gap: 8px;
  }
  .achat-conv-hdr-av {
    width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-size: .7rem; font-weight: 800; color: #fff;
    background: linear-gradient(135deg, #4f8ef7, #7c3aed);
  }
  .achat-conv-hdr-name { font-size: .9rem; font-weight: 700; color: var(--text-1); font-family: var(--display); line-height: 1.2; }
  .achat-conv-hdr-email { font-size: .71rem; color: var(--text-3); }

  /* Mobile toggle button in header */
  .achat-mob-toggle {
    width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
    background: rgba(255,255,255,.05); border: 1px solid var(--line-2);
    display: flex; align-items: center; justify-content: center;
    color: var(--text-2); cursor: pointer; transition: background .13s;
  }
  .achat-mob-toggle:hover { background: rgba(255,255,255,.09); }

  /* ── Applicant info + status panel ── */
  .achat-app-panel {
    border-bottom: 1px solid var(--line);
    background: var(--bg-1);
    flex-shrink: 0;
    overflow: hidden;
    transition: max-height .28s cubic-bezier(.16,1,.3,1);
    max-height: 0;
  }
  .achat-app-panel.open { max-height: 260px; }

  .achat-app-panel-inner {
    padding: 12px 14px 14px;
    display: flex; flex-direction: column; gap: 10px;
    animation: achat-fadein .2s;
  }

  .achat-app-info-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 6px 12px;
  }
  .achat-app-info-item {}
  .achat-app-info-label {
    font-size: .6rem; font-weight: 800; letter-spacing: .07em;
    text-transform: uppercase; color: var(--text-3); margin-bottom: 1px;
  }
  .achat-app-info-val {
    font-size: .8rem; color: var(--text-1); font-weight: 500;
  }

  .achat-status-row {
    display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
  }
  .achat-status-label {
    font-size: .72rem; font-weight: 700; color: var(--text-3);
    margin-right: 2px; white-space: nowrap;
  }
  .achat-status-btn {
    padding: 4px 10px; border-radius: 100px; font-size: .72rem; font-weight: 700;
    border: 1px solid transparent; cursor: pointer; font-family: inherit;
    transition: all .13s; white-space: nowrap;
  }
  .achat-status-btn.pending  { background: rgba(245,158,11,.1);  border-color: rgba(245,158,11,.3);  color: var(--amber); }
  .achat-status-btn.reviewed { background: rgba(79,142,247,.1);  border-color: rgba(79,142,247,.3);  color: var(--blue); }
  .achat-status-btn.accepted { background: rgba(34,197,94,.1);   border-color: rgba(34,197,94,.3);   color: var(--green); }
  .achat-status-btn.rejected { background: rgba(239,68,68,.1);   border-color: rgba(239,68,68,.3);   color: var(--red); }
  .achat-status-btn.active.pending  { background: rgba(245,158,11,.22); border-color: rgba(245,158,11,.6); }
  .achat-status-btn.active.reviewed { background: rgba(79,142,247,.22); border-color: rgba(79,142,247,.6); }
  .achat-status-btn.active.accepted { background: rgba(34,197,94,.22);  border-color: rgba(34,197,94,.6); }
  .achat-status-btn.active.rejected { background: rgba(239,68,68,.22);  border-color: rgba(239,68,68,.6); }
  .achat-status-btn:disabled { opacity: .45; cursor: default; }

  .achat-interview-btn {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 4px 11px; border-radius: 8px;
    background: rgba(124,58,237,.12); border: 1px solid rgba(124,58,237,.3);
    color: #a78bfa; font-size: .72rem; font-weight: 700;
    cursor: pointer; font-family: inherit; transition: background .13s;
    white-space: nowrap;
  }
  .achat-interview-btn:hover:not(:disabled) { background: rgba(124,58,237,.22); }
  .achat-interview-btn:disabled { opacity: .4; cursor: default; }

  /* Panel toggle button in header */
  .achat-panel-btn {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 4px 10px; border-radius: 8px;
    background: rgba(255,255,255,.05); border: 1px solid var(--line-2);
    color: var(--text-2); font-size: .72rem; font-weight: 600;
    cursor: pointer; font-family: inherit; transition: all .13s;
    white-space: nowrap;
  }
  .achat-panel-btn:hover { background: rgba(255,255,255,.09); color: var(--text-1); }
  .achat-panel-btn.active { background: rgba(79,142,247,.1); border-color: rgba(79,142,247,.4); color: var(--blue); }

  /* Toast inside chat */
  .achat-toast {
    position: absolute; bottom: 80px; left: 50%; transform: translateX(-50%);
    background: var(--bg-0,#0a0f1e); border: 1px solid var(--line);
    border-radius: 9px; padding: 7px 14px; font-size: .8rem; font-weight: 600;
    color: var(--text-1); display: flex; align-items: center; gap: 6px;
    z-index: 300; box-shadow: 0 8px 28px rgba(0,0,0,.4);
    animation: achat-fadein .2s; pointer-events: none; white-space: nowrap;
  }
  .achat-toast.success { border-color: rgba(34,197,94,.4); color: var(--green); }
  .achat-toast.error   { border-color: rgba(239,68,68,.4); color: var(--red); }

  /* ── Messages area ── */
  .achat-msgs {
    flex: 1; overflow-y: auto;
    padding: 14px 14px 8px;
    display: flex; flex-direction: column; gap: 6px;
  }
  .achat-msgs::-webkit-scrollbar { width: 3px; }
  .achat-msgs::-webkit-scrollbar-thumb { background: rgba(255,255,255,.07); border-radius: 2px; }

  .achat-date-sep {
    display: flex; align-items: center; gap: 10px;
    font-size: .62rem; color: var(--text-3); font-weight: 800;
    letter-spacing: .08em; text-transform: uppercase; flex-shrink: 0;
    margin: 4px 0;
  }
  .achat-date-sep::before,.achat-date-sep::after { content:''; flex:1; height:1px; background: var(--line); }

  .achat-msg { display: flex; flex-direction: column; max-width: 70%; }
  .achat-msg.me   { align-self: flex-end; align-items: flex-end; }
  .achat-msg.them { align-self: flex-start; align-items: flex-start; }
  .achat-bubble {
    padding: 9px 13px; border-radius: 16px;
    font-size: .86rem; line-height: 1.55;
    word-break: break-word; white-space: pre-wrap;
  }
  .achat-msg.me   .achat-bubble { background: linear-gradient(135deg,#4f8ef7,#6366f1); color:#fff; border-bottom-right-radius:4px; }
  .achat-msg.them .achat-bubble { background: var(--surface); border:1px solid var(--line-2); color: var(--text-1); border-bottom-left-radius:4px; }
  .achat-msg-time  { font-size:.62rem; color:var(--text-3); margin-top:3px; padding:0 3px; }
  .achat-msg-label { font-size:.62rem; font-weight:700; color:var(--text-3); margin-bottom:3px; padding:0 3px; }

  .achat-empty-msgs {
    flex:1; display:flex; flex-direction:column;
    align-items:center; justify-content:center;
    gap:8px; color:var(--text-3); text-align:center;
  }
  .achat-empty-msgs p { font-size:.8125rem; max-width:200px; margin:0; }

  /* ── Input row ── */
  .achat-input-row {
    display: flex; align-items: flex-end; gap: 8px;
    padding: 10px 12px 14px;
    border-top: 1px solid var(--line); background: var(--bg-1); flex-shrink: 0;
  }
  .achat-textarea {
    flex: 1; resize: none;
    background: var(--surface); border: 1px solid var(--line-2);
    border-radius: 12px; padding: 9px 12px;
    font-family: var(--body); font-size: .875rem; color: var(--text-1);
    outline: none; min-height: 40px; max-height: 120px; line-height: 1.5;
    transition: border-color .14s;
  }
  .achat-textarea::placeholder { color: var(--text-3); }
  .achat-textarea:focus { border-color: var(--blue); box-shadow: 0 0 0 3px rgba(79,142,247,.1); }
  .achat-send-btn {
    width: 40px; height: 40px; flex-shrink: 0; border-radius: 11px;
    background: linear-gradient(135deg, #4f8ef7, #6366f1);
    border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center; color: #fff;
    transition: transform .14s, box-shadow .14s, opacity .14s;
  }
  .achat-send-btn:hover:not(:disabled) { transform:scale(1.06); box-shadow:0 4px 14px rgba(79,142,247,.4); }
  .achat-send-btn:disabled { opacity:.3; cursor:default; }

  /* ── Quick reply templates ── */
  .achat-templates-bar {
    padding: 8px 12px 6px;
    border-top: 1px solid var(--line);
    background: var(--bg-1);
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .achat-templates-label {
    font-size: .6rem; font-weight: 800; letter-spacing: .08em;
    text-transform: uppercase; color: var(--text-3);
  }
  .achat-templates-list {
    display: flex; flex-wrap: wrap; gap: 6px;
  }
  .achat-tpl-btn {
    padding: 5px 11px; border-radius: 100px;
    background: rgba(79,142,247,.07); border: 1px solid rgba(79,142,247,.22);
    color: var(--blue); font-family: var(--body); font-size: .72rem; font-weight: 600;
    cursor: pointer; transition: background .13s, border-color .13s;
    white-space: nowrap; max-width: 220px;
    overflow: hidden; text-overflow: ellipsis;
  }
  .achat-tpl-btn:hover { background: rgba(79,142,247,.16); border-color: rgba(79,142,247,.45); }
`;
export default STYLES;
